export const NEW_RESIDENT = "NEW_RESIDENT";
